import { Settings as SettingsIcon } from "@mui/icons-material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import version from "../../../package.json";
import AuthService from "../../api/AuthService";
import { CustomButton } from "../../components/CustomButton/CustomButton";
import { FloatingButtons } from "../../components/FloatingButtons/FloatingButtons";
import { Info } from "../../components/Info/Info";
import { FeedbackIcon } from "../../icons/FeedbackIcon/FeedbackIcon";
import { AppLayout } from "../../layout/AppLayout/AppLayout";
import { RootState } from "../../store";
import { resetState } from "../../store/appointment-slice";
import { clockActions } from "../../store/clock-slice";
import { customerDeficienciesActions } from "../../store/customer-deficiencies-slice";
import { creatingDeficiencyActions } from "../../store/deficiencies-slice";
import { creatingDocumentationActions } from "../../store/documentation-slice";
import { overviewAppointmentSliceActions } from "../../store/overview-appointment-slice";
import { propertyActions } from "../../store/property-slice";
import { activeTabsActions } from "../../store/tabs-slice";
import { ROLES, userSliceActions } from "../../store/user-slice";
import styles from "../../styles/settings.module.css";

export const Settings = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const { isOnline } = useSelector((state: RootState) => state.online);
  const isCustomerAdmin = useSelector(
    (state: RootState) => state.user.isCustomerAdmin
  );
  const isAdmin = useSelector((state: RootState) =>
    state.user.roles.some((role) => role === ROLES.ADMIN || role === "kunde.admin")
  );
  const isMainAdmin = useSelector((state: RootState) =>
    state.user.roles.some((role) => role === ROLES.ADMIN)
  );
  const isPropertyManager = useSelector((state: RootState) =>
    state.user.roles.some((role) => role === "kunde.objektbetreuer")
  );

  const RedirectToLink = () =>
    window.open("http://help.pestix.de/de", "_blank");

  useEffect(() => {
    if (isOnline) {
      setError("");
    }
  }, [isOnline]);

  const handleSignOut = () => {
    if (!isOnline) {
      setError(() => t("NoInternet"));
      return;
    }

    AuthService.SignOut()
      .then(() => {
        localStorage.clear();
        dispatch(userSliceActions.resetState());
        dispatch(clockActions.resetState());
        dispatch(customerDeficienciesActions.resetState());
        dispatch(creatingDocumentationActions.resetState());
        dispatch(propertyActions.setViewOnly(false));
        dispatch(creatingDeficiencyActions.resetState());
        dispatch(activeTabsActions.setDashbaordUrl(""));
        dispatch(overviewAppointmentSliceActions.resetState());
        dispatch(resetState());
        navigate("/");
      })
      .catch(() => {
        setError(() => t("Error"));
      });
  };

  return (
    <AppLayout hideHeader={isCustomerAdmin}>
      <div className={styles["container"]}>
        <div className={styles["settings__heading"]}>
          <p className={styles["settings__title"]}>
            {<SettingsIcon />} {t("Settings")}
          </p>
        </div>

        <div className={styles["settings-content"]}>
          {error && <Info type="error">{error}</Info>}

          <div className={styles["settings-top"]}>
            <>
              {isMainAdmin && <div
                className={`${styles["settings-bottom__feedback-link"]} ${styles["flex"]}`}
                onClick={() => {
                  navigate("/product-management");
                }}
              >
                <h2 className={styles["item"]}>{t("MaterialManagement")}</h2>
              </div>}
              {isAdmin && <div
                className={`${styles["settings-bottom__feedback-link"]} ${styles["flex"]}`}
                onClick={() => {
                  navigate("/user-management");
                }}
              >
                <h2 className={styles["item"]}>{t("UserManagement")}</h2>
              </div>}
            </>

            {(isCustomerAdmin || isPropertyManager) && (
              <div
                className={`${styles["settings-bottom__feedback-link"]} ${styles["flex"]}`}
                onClick={() => {
                  navigate("/email-notifications");
                }}
              >
                <h2 className={styles["item"]}>{t("EmailNotifications")}</h2>
              </div>
            )}
          </div>
          <div className={styles["settings-bottom"]}>
            {/* {isCustomerAdmin && (
              <div
                className={styles["settings-bottom__feedback-link"]}
                onClick={RedirectToLink}
              >
                <FeedbackIcon handleFeedbackClicked={() => {}} /> Roadmap
              </div>
            )} */}
            {isCustomerAdmin && (
              <div
                className={styles["settings-bottom__feedback-link"]}
                onClick={RedirectToLink}
              >
                <FeedbackIcon handleFeedbackClicked={() => { }} />Hilfe Center
              </div>
            )}

            <FloatingButtons>
              <CustomButton color="gray" onClick={handleSignOut}>
                {t("SignOut")}
              </CustomButton>
            </FloatingButtons>
          </div>
        </div>
        <span className={styles.version}>{version.version}</span>
      </div>
    </AppLayout>
  );
};
